import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorEditComponent } from './editor-edit.component';
import { EditorModule as tinymceEditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    tinymceEditorModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [EditorEditComponent],
  exports : [EditorEditComponent],
  // providers: [
  //   { provide: TINYMCE_SCRIPT_SRC, useValue: "tinymce/tinymce.min.js" }
  // ]
})
export class EditorEditModule { }
